var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVisa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 15,
  viewBox: "0 0 49 15",
  style: {
    verticalAlign: "middle"
  }
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 214.815,
  y1: -364.312,
  x2: 263.317,
  y2: -363.862,
  gradientTransform: "matrix(.805 0 0 -.805 -170.696 -285.733)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#191E5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#142787",
  stopOpacity: 0.819
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M19.73.14h3.962l-2.478 14.53h-3.96z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  gradientUnits: "userSpaceOnUse",
  x1: 157.834,
  y1: -272.49,
  x2: 206.32,
  y2: -272.04,
  gradientTransform: "matrix(1 0 0 -1 -155.769 -264.731)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#191E5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#142787",
  stopOpacity: 0.819
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M35.598.61C34.812.316 33.584 0 32.048 0c-3.913 0-6.67 1.97-6.692 4.795-.02 2.09 1.967 3.252 3.47 3.95 1.542.71 2.06 1.166 2.052 1.802-.01.973-1.23 1.418-2.37 1.418-1.585 0-2.427-.222-3.727-.764l-.51-.228-.554 3.25c.924.406 2.635.757 4.41.777 4.165 0 6.868-1.95 6.897-4.967.016-1.652-1.04-2.91-3.324-3.948-1.386-.67-2.233-1.12-2.226-1.8 0-.605.72-1.25 2.27-1.25 1.295-.02 2.232.262 2.965.557l.353.167.535-3.15"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  gradientUnits: "userSpaceOnUse",
  x1: 157.835,
  y1: -272.663,
  x2: 206.32,
  y2: -272.213,
  gradientTransform: "matrix(1 0 0 -1 -155.769 -264.731)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#191E5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#142787",
  stopOpacity: 0.819
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M45.754.267h-3.06c-.948 0-1.66.26-2.075 1.205l-5.882 13.315h4.158s.68-1.79.834-2.184l5.072.007c.12.51.48 2.177.48 2.177h3.676L45.754.267M40.87 9.633l1.58-4.062c-.026.04.323-.84.522-1.387l.268 1.254s.758 3.47.918 4.196H40.87z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.805 0 0 .805 8.091 9.256)"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  gradientUnits: "userSpaceOnUse",
  x1: 256.474,
  y1: -462.181,
  x2: 304.963,
  y2: -461.731,
  gradientTransform: "matrix(.805 0 0 -.805 -213.711 -374.142)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#191E5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#142787",
  stopOpacity: 0.819
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M7.28-11.17L2.464 1.14 1.95-1.365c-.895-2.884-3.688-6.008-6.81-7.57L-.46 6.85l5.206-.006 7.744-18.015H7.28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  gradientUnits: "userSpaceOnUse",
  x1: 256.424,
  y1: -456.961,
  x2: 304.911,
  y2: -456.512,
  gradientTransform: "matrix(.805 0 0 -.805 -213.711 -374.142)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#191E5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#142787",
  stopOpacity: 0.819
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  d: "M-2.003-11.18h-7.933l-.064.373C-3.828-9.31.256-5.702 1.95-1.364L.226-9.654c-.298-1.145-1.162-1.487-2.23-1.527"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  gradientUnits: "userSpaceOnUse",
  x1: 157.78,
  y1: -267.037,
  x2: 206.267,
  y2: -266.587,
  gradientTransform: "matrix(1 0 0 -1 -155.769 -264.731)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#191E5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#142787",
  stopOpacity: 0.819
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  d: "M4.333 2.616c-.082-.306-.167-.488-.48-.657l1.167.523"
})))));
export default SvgVisa;